import React from 'react'
import IcMan from '../../assets/images/manwithphone.png'
import IcFlower from '../../assets/images/flower.png'
import { ReactComponent as Icshoppe } from "../../assets/icons/ic-shoppe.svg"
import {ReactComponent as IcTokped} from "../../assets/icons/ic-tokopedia.svg"
import {ReactComponent as IcFacebook} from "../../assets/icons/ri_facebook-fill.svg"
// import {ReactComponent as IcTwitter} from "../../assets/icons/prime_twitter.svg"
import {ReactComponent as IcInstagram} from "../../assets/icons/ri_instagram-fill.svg"
// import {ReactComponent as IcTiktok} from "../../assets/icons/ic_baseline-tiktok.svg"
import  data  from '../../data/staticData'

export const Footer = () => {
    return (
        <div>
            <div className="flex w-full">
                <div className="bg-[#ECF3F5] h-[30rem] w-[45%] grid items-end p-6">
                    <img src={IcMan} alt="icman" />
                </div>
                <div className="relative grid p-6 place-items-center bg-[#325465] h-[30rem] w-full">
                    <div className="grid w-full text-left text-white gap-3 font-semibold">
                        <h1 className="text-2xl">Contact Information</h1>
                        <div>
                            <h2>Official E-Commerce</h2>
                            <div className="flex pt-2">
                                <div className="flex items-center space-x-2">
                                    <div className="rounded-full p-1 bg-[#548CA8]">
                                        <Icshoppe className='cursor-pointer' onClick={() => window.open(data.storeCredentials.shoppeeUrl)} />
                                    </div>
                                    <div className="rounded-full p-1 bg-[#548CA8]">
                                        <IcTokped className='cursor-pointer' onClick={() => window.open(data.storeCredentials.tokpedUrl)}/>
                                    </div>
                                    <p>agirosparfum</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h2>Our Social Media</h2>
                             <div className="flex space-x-4 pt-2">
                                <IcFacebook className='cursor-pointer' onClick={() => window.open(data.storeCredentials.facebookUrl)} />
                                {/* <IcTwitter /> */}
                                <IcInstagram className='cursor-pointer' onClick={() => window.open(data.storeCredentials.instagramUrl)} />
                                {/* <IcTiktok /> */}
                            </div>
                        </div>
                    </div>
                    <img className='absolute bottom-0 right-0' src={IcFlower} alt="icman" />
                </div>
            </div>
            <div>
                <p className="text-sm p-4">© Copyright by <span className="text-[#548CA8] font-semibold">Agiros Parfume</span></p>
            </div>
        </div>
    )
}